import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class Globals {
  constructor(@Inject(PLATFORM_ID) platformId: string) {
    this.isBrowser = isPlatformBrowser(platformId);
  }
  isBrowser: boolean;
  TEMPLATE_TYPES = {
    SIDEBAR: 'sidebar',
    ARTICLE: 'article',
    TECHNICAL: 'technical',
    LISTING: 'listing',
    SERVICE_DISCOVERY: 'service_discovery',
    LANDING: 'landing',
    REDOC: 'redoc',
    PRODUCT: 'product',
    HOME: 'home',
    BUSINESS_TYPE: 'business-type',
    HOMEPAGE: 'homepage',
    LEARNINGPAGE: 'learningpage',
    API_OVERVIEW: 'api-overview',
    API_OVERVIEW_FAMILY: 'app-api-overview-family',
    PRODUCT_LANDING: 'product-landing',
    APP_PRODUCT_LANDING: 'app-product-landing',
    CATEGORY: 'category',
    DOC_PAGE: 'doc-page',
    APP_API_DOC: 'app-api-doc',
    PROD_DOC_PAGE: 'prod-doc-page',
    ARTICLE_PAGE: 'article',
    SDK_PAGE: 'sdk',
    PUBLIC: 'public',
    SUPPORT_PAGE: 'support-page',
    GLOSSARY_PAGE: 'glossary-page',
    CONTACT_PAGE: 'contact-page',
    CONTACT_SALES: 'contact-sales',
    SEARCH_RESULT: 'searchresult',
    ALL_PRODUCT: 'all-product',
    SOLUTION_FINDER: 'solution-finder',
    LEGACY_DASHBOARD: 'legacy-dashboard',
  };
  DATE_FORMAT = 'D MMM YYYY';
  static emailValidationRegEx = '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[.a-zA-Z]{2,7}$';
  CONTACT_SALES_SEC_HEADER_TITLE = 'Need Help?';
  CONTACT_SALES_GENERIC_TITLE = 'Get in touch with Worldpay';
  CONTACT_SALES_GENERIC_SUBHEADING = 'Ready to partner with Us?';
  CONTACT_SALES_GENERIC_DETAILS = 'Connect with our team by completing the form below.';
  CONTACT_SALES_PRODUCT_TITLE = 'Need help with';
  CONTACT_SALES_PRODUCT_SUBHEADING = 'Get in touch!';
  CONTACT_SALES_PRODUCT_DETAILS =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. ' +
    'Proin vitae mi pharetra, ultricies ligula et, facilisis dolor. ' +
    'Aenean feugiat erat ac arcu consectetur commodo vitae ac enim.';

  internalDomains: string[] = ['@worldpay.com', '@fisglobal.com'];

  readonly URL_TEMPLATE_PATTERNS: { pattern: RegExp; template: string }[] = [
    { pattern: /^\/$/, template: this.TEMPLATE_TYPES.HOMEPAGE },
    { pattern: /^\/solutionfinder/, template: this.TEMPLATE_TYPES.CONTACT_PAGE },
    { pattern: /^\/contact\/?$/, template: this.TEMPLATE_TYPES.CONTACT_PAGE },
    { pattern: /^\/contact\/.+$/, template: this.TEMPLATE_TYPES.CONTACT_SALES },
    { pattern: /^\/solution-finder/, template: this.TEMPLATE_TYPES.SOLUTION_FINDER },
    { pattern: /\/api-specification/, template: this.TEMPLATE_TYPES.REDOC },
    { pattern: /^\/apis\/?$/, template: this.TEMPLATE_TYPES.ALL_PRODUCT },
    { pattern: /^\/apis\/ips-3130\/.+$/, template: this.TEMPLATE_TYPES.PRODUCT },
    { pattern: /^\/apis\/ips-3140\/.+$/, template: this.TEMPLATE_TYPES.PRODUCT },
    { pattern: /^\/apis\/ips-3150\/.+$/, template: this.TEMPLATE_TYPES.PRODUCT },
    { pattern: /^\/apis\/ips-3160\/.+$/, template: this.TEMPLATE_TYPES.PRODUCT },
    { pattern: /^\/apis\/ips-3170\/.+$/, template: this.TEMPLATE_TYPES.PRODUCT },
    { pattern: /^\/apis\/ips3120\/.+$/, template: this.TEMPLATE_TYPES.PRODUCT },
    { pattern: /^\/apis\/(?!category(?:\/|$))[^/]+\/[^/]+/, template: this.TEMPLATE_TYPES.DOC_PAGE },
    { pattern: /^\/support\/?$/, template: this.TEMPLATE_TYPES.SUPPORT_PAGE },
    { pattern: /^\/glossary(?:#.*)?$/, template: this.TEMPLATE_TYPES.GLOSSARY_PAGE },
    { pattern: /^\/support\/[^/]+\/?$/, template: this.TEMPLATE_TYPES.DOC_PAGE },
    { pattern: /^\/support\/[^/]+\/[^/]+/, template: this.TEMPLATE_TYPES.DOC_PAGE },
    { pattern: /^\/plugins\/[^/]+\/[^/]+/, template: this.TEMPLATE_TYPES.DOC_PAGE },
    { pattern: /^\/core\/[^/]+\/[^/]+/, template: this.TEMPLATE_TYPES.DOC_PAGE },
    { pattern: /^\/solutions\/[^/]+(\/)?$/, template: this.TEMPLATE_TYPES.DOC_PAGE },
    { pattern: /^\/business-?type\/[^/]+(\/)?$/, template: this.TEMPLATE_TYPES.BUSINESS_TYPE },
    { pattern: /^\/usecase(\/[^/]+)?(\/)?$/, template: this.TEMPLATE_TYPES.BUSINESS_TYPE },
    { pattern: /^\/learning(\/[^/]+)?(\/)?$/, template: this.TEMPLATE_TYPES.LEARNINGPAGE },
    { pattern: /^\/learn\/?$/, template: this.TEMPLATE_TYPES.LEARNINGPAGE },
    { pattern: /^\/learn\/[^/]+(?:\/[^/]+)?\/?$/, template: this.TEMPLATE_TYPES.PRODUCT_LANDING },
    { pattern: /^\/learn\/.+$/, template: this.TEMPLATE_TYPES.ARTICLE_PAGE },
    { pattern: /^\/plugins(\/[^/]+)?(\/)?$/, template: this.TEMPLATE_TYPES.LEARNINGPAGE },
    { pattern: /^\/artificial-intelligence(\/[^/]+)?(\/)?$/, template: this.TEMPLATE_TYPES.LEARNINGPAGE },
    { pattern: /^\/apis\/(?!category(?:\/|$))[^/]+(\/)?$/, template: this.TEMPLATE_TYPES.API_OVERVIEW },
    { pattern: /^\/terms-of-service/, template: this.TEMPLATE_TYPES.API_OVERVIEW },
    { pattern: /^\/apis\/category(\/.*)?$/, template: this.TEMPLATE_TYPES.CATEGORY },
    { pattern: /^\/legacy\/dashboard\/credentials/, template: this.TEMPLATE_TYPES.LEGACY_DASHBOARD },
    { pattern: /^\/developer-resources\/?$/, template: this.TEMPLATE_TYPES.API_OVERVIEW },
    { pattern: /^\/developer-resources\/developer-dashboard(?:\/.*)?\/?$/, template: this.TEMPLATE_TYPES.DOC_PAGE },
    { pattern: /^\/developer-resources\/try-experience(?:\/.*)?\/?$/, template: this.TEMPLATE_TYPES.DOC_PAGE },
    { pattern: /^\/paymetric(?:\/.*)?(?:#.*)?$/, template: this.TEMPLATE_TYPES.API_OVERVIEW }
  ];

  inferSkeletonTemplate(url: string): string | null {
    const cleanUrl = url.split('?')[0];
    const match = this.URL_TEMPLATE_PATTERNS.find(({ pattern }) => pattern.test(cleanUrl));
    return match ? match.template : this.setFallbackSkeleton();
  }

  showDocSecHeaderSkeletonLoader(meta: any, url: string, inferredTemplate?: string | null): boolean {
    const resolvedTemplate = inferredTemplate ?? this.inferSkeletonTemplate(url);
    const shouldShowLoaderFromRoute =
      resolvedTemplate === this.TEMPLATE_TYPES.REDOC || resolvedTemplate === this.TEMPLATE_TYPES.DOC_PAGE;

    return (
      shouldShowLoaderFromRoute && !meta?.template && meta?.['secondary-nav'] !== false && meta?.['sec-nav'] !== false
    );
  }

  private setFallbackSkeleton(): string {
    return this.TEMPLATE_TYPES.BUSINESS_TYPE;
  }
}
